import { defineComponent, ref } from 'vue';
import HoistComponent from '../../hoist-component/HoistComponent.vue.js';
import UiModal from '../../ui-modal/UiModal.vue.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "PortfolioAction",
  props: {
    active: { type: Boolean, required: false, default: true }
  },
  setup(__props) {
    const props = __props;
    const isModalVisible = ref(false);
    const openModal = () => {
      isModalVisible.value = true;
    };
    const closeModal = () => {
      isModalVisible.value = false;
    };
    return { __sfc: true, props, isModalVisible, openModal, closeModal, HoistComponent, UiModal };
  }
});

export { _sfc_main as default };
